import { Dispatch } from 'redux';

import { requestHandler } from '../../api';

export const getAllDocumentDiscounts = async (dispatch: Dispatch) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/documentDiscount`,
    dispatch,
  });
  if (response) return response.data;
};

export const getDocumentDiscount = async (dispatch: Dispatch, id: string) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/documentDiscount/${id}`,
    dispatch,
  });
  if (response) return response.data;
};

export const createDocumentDiscount = async (dispatch: Dispatch, data: any) => {
  const response = await requestHandler({
    method: 'post',
    url: `internal/documentDiscount`,
    data,
    dispatch,
  });
  if (response) return response.data;
};

export const updateDocumentDiscount = async (
  dispatch: Dispatch,
  id: number,
  data: any,
) => {
  const response = await requestHandler({
    method: 'patch',
    url: `internal/documentDiscount/${id}`,
    data,
    dispatch,
  });
  if (response) return response.data;
};
